(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/digital-tickets-provider.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/digital-tickets-provider.js');
"use strict";


const {
  createContext,
  useEffect,
  useReducer
} = React;
const {
  reducer,
  initialState
} = svs.ticket_partner.digitalTickets;
const LOCAL_STORAGE_EXPIRATION_TIME = 60 * 60 * 1000;
const DigitalTicketsContext = createContext();
svs.ticket_partner.DigitalTicketsContext = DigitalTicketsContext;
const DigitalTicketsProvider = _ref => {
  let {
    children
  } = _ref;
  const [digitalTicketsState, setDigitalTicketsState] = svs.ticket_partner.sharedComponents.hooks.useLocalStorage('digitalTickets.state', false, LOCAL_STORAGE_EXPIRATION_TIME);
  const initializer = () => digitalTicketsState || initialState;
  const [state, dispatch] = useReducer(reducer, initialState, initializer);
  useEffect(() => {
    setDigitalTicketsState(state);
  }, [state]);
  return React.createElement(DigitalTicketsContext.Provider, {
    value: {
      state,
      dispatch
    }
  }, children);
};
svs.ticket_partner.DigitalTicketsProvider = DigitalTicketsProvider;

 })(window);